import React, { useState, useEffect } from "react";
import { Row ,Col ,Image} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Icon from "react-feather";
import ImageUpload from "../../../common/ImageUpload";
import { uploadUserProfileAction } from "../../../redux/actions/studentActions";
import defaultAvatar from '../../../assets/images/default_avatar.png'
const Bio = (props) => {
  const dispatch = useDispatch();
  const { loader ,studentPaymentHistoryData,studentProfileDetails  } = useSelector((state) => state.student);
  const [profileFile, setProfileFile] = useState([])
  const uploadFiles = (files)=>{
    setProfileFile(files)
  }
  const uploadUserProfile = async()=>{
    const studentReqObj = new FormData();
      if(Object.keys(profileFile).length > 0){
        studentReqObj.append('avatar', profileFile, profileFile.name);
      }
      studentReqObj.append('StudentId',studentProfileDetails.id)
      await dispatch(uploadUserProfileAction(studentReqObj))
      setProfileFile({})
  }
  return (
    <div className="page-wrapper">
          <div className="spacer"></div>
          
          <Row>
              {/* User card */}
              
                            <Col md={6} lg={4}>
                            <div className="profile-left-content">
                                <div className="card mb-4">
                                    <div className="card-body">
                                        {/* <div className="card-header">
                                            <h5 className="card-title">Info</h5>
                                        </div> */}
                                        {/* <span><u>Student Info</u></span> */}
                                        <ul className="info">
                                            <li> 
                                                <Icon.MapPin 
                                                    className="icon"
                                                /> 
                                                Location: {studentProfileDetails.bio.location}
                                            </li>
                                            <li> 
                                                <Icon.Edit 
                                                    className="icon"
                                                /> 
                                                Language: {studentProfileDetails.bio.languages}
                                            </li>
                                            <li> 
                                                <Icon.Calendar 
                                                    className="icon"
                                                /> 
                                                Joined: Joined {studentProfileDetails.bio.dateOfJoin}
                                            </li>
                                            <li> 
                                                <Icon.Aperture 
                                                    className="icon"
                                                /> 
                                                Birthday: Born {studentProfileDetails.bio.dob}
                                            </li>
                                            <li> 
                                                <Icon.Phone 
                                                    className="icon"
                                                /> 
                                                Phone: +91 {studentProfileDetails.bio.phoneNumber}
                                            </li>
                                            <li> 
                                                <Icon.Mail 
                                                    className="icon"
                                                /> 
                                                Email: {studentProfileDetails.bio.email}
                                            </li>
                                            <hr/>
                                            <li> 
                                                <Icon.Mail 
                                                    className="icon"
                                                /> 
                                                Father Name: {studentProfileDetails.bio.fatherName}
                                            </li>
                                            <li> 
                                                <Icon.Phone 
                                                    className="icon"
                                                /> 
                                                Father Phone: +91 {studentProfileDetails.bio.fatherMobileNumber}
                                            </li>
                                            <li> 
                                                <Icon.Mail 
                                                    className="icon"
                                                /> 
                                                Mother Name: {studentProfileDetails.bio.motherName}
                                            </li>
                                            <li> 
                                                <Icon.Phone 
                                                    className="icon"
                                                /> 
                                               Mother Phone: +91 {studentProfileDetails.bio.motherMobileNumber}
                                            </li>
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Col>

              <Col md={6} lg={4}>
                            <div className="single-user-card hover-card mb-4">
                                <div style={{padding: "40px"}}>
                                    <Image 
                                        src={studentProfileDetails.bio.profileUrl ? studentProfileDetails.bio.profileUrl : defaultAvatar } 
                                        roundedCircle
                                        alt="User Image"
                                    />
                                    <h4 className="mb-0 mt-4">{studentProfileDetails.bio.name}  </h4>
                                    <p><ImageUpload uploadFile={uploadFiles} isPreviewRequired={false} uploadAction={uploadUserProfile} fileData={profileFile}/></p>
                                   
                                </div>
                                <ul className="user-card-foot">
                                    <li>
                                        Branch
                                        <span>{studentProfileDetails.Branch.name}</span>
                                    </li>
                                    <li className="bor-lr">
                                        Class Group
                                        <span>{studentProfileDetails.ClassGroup.name}</span>
                                    </li>
                                    <li>
                                        Class Name
                                        <span>{studentProfileDetails.ClassRoom ? studentProfileDetails.ClassRoom.name : <br/> }</span>
                                    </li>
                                </ul>
                            </div>
                        </Col>

                        
          </Row>
    </div>
  );
};

export default Bio;
